import React, { useState, useEffect, useCallback } from 'react';
import { subscribeToast } from '../../hooks/useToast';
import '../../style/toast.css';

const ICON_MAP = {
  success: 'check_circle',
  error:   'error',
  info:    'info',
};

function ToastItem({ toast, onRemove }) {
  const [leaving, setLeaving] = useState(false);

  const dismiss = useCallback(() => {
    setLeaving(true);
    setTimeout(() => onRemove(toast.id), 240);
  }, [toast.id, onRemove]);

  useEffect(() => {
    const timer = setTimeout(dismiss, toast.duration);
    return () => clearTimeout(timer);
  }, [dismiss, toast.duration]);

  return (
    <div className={`toast toast-${toast.type}${leaving ? ' toast-leaving' : ''}`}>
      <span className={`material-symbols-rounded toast-icon`}>
        {ICON_MAP[toast.type]}
      </span>
      <span className="toast-msg">{toast.msg}</span>
      <button className="toast-close" onClick={dismiss} aria-label="닫기">✕</button>
    </div>
  );
}

function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const unsubscribe = subscribeToast((item) => {
      setToasts((prev) => [...prev, item]);
    });
    return unsubscribe;
  }, []);

  const remove = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <ToastItem key={t.id} toast={t} onRemove={remove} />
      ))}
    </div>
  );
}

export default ToastContainer;
